<template>
	<div class="py-8 relative">
		<h2 class="font-serif font-bold text-4xl text-black mb-4 text-center">
			Select Your Option
		</h2>
		<div class="flex flex-wrap">
			<div class="flex w-full md:w-1/2 justify-center">
				<Block title="Small Business" description="Small business? Big goals? Learn about our small business solutions that scale to your needs without limiting you as you grow to dominate your industry." v-bind:link="{ name: 'small-business' }" cta="Get Started"></Block>
			</div>
			<div class="flex w-full md:w-1/2 justify-center">
				<Block title="Large Enterprise" description="As your software infrastructure becomes more complex, so does the task of managing it. Our enterprise solutions make big projects simple." v-bind:link="{ name: 'large-enterprise' }" cta="Estimate Costs"></Block>
			</div>
			<div class="flex w-full md:w-1/2 justify-center">
				<Block title="Freelancer" description="Freelancers love us, and so will you! Our goal is to handle the heavy lifting so you can focus on what you do best, building those amazing websites!" v-bind:link="{ name: 'freelancer' }" cta="Get Started"></Block>
			</div>
			<div class="flex w-full md:w-1/2 justify-center">
				<Block title="Partner" description="We LOVE our partners! If you are looking for recurring income, sign up now. Send customers our way, and make 10% commission for the life of their account." v-bind:link="{ name: 'partner' }" cta="Register Now"></Block>
			</div>
		</div>
	</div>
</template>

<script>
import Block from "./Block";

export default {
  name: "Main",
  components: {
    Block
  }
};
</script>
